import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <nav className="nav-bar">
        <div className="logo-container">
          <img
            src="/images/name.png"
            alt="Garrett Albracht"
            className="logo-image"
          />
        </div>
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/projects">Projects</Link></li>
          <li><Link to="/experience">Experience</Link></li>
          <li><Link to="/resume">Resume</Link></li>
        </ul>
      </nav>

    </header>
  );
};

export default Header;
